import React, {Component} from 'react'
import {constants} from "../data/constants";
import {downLoadVisit} from "../data/analytics";

export class howitworks extends Component {
	render() {
		return (
			<div id="hiw">
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<div className="text-center">
								<h2 className={"section-title"}>
									How it works
								</h2>

								<div className="row pt-5 pb-5">
									<div className="col-md-4 mb-5">
										<div className="mb-3 mx-auto hiw-circle rounded-circle bkg-one">
											<h1>1</h1>
										</div>
										<h4>
											<strong>Download the app</strong>
										</h4>
										<p className="mb-0">
											Get the app from the app store or play store using one of
											the links below.
										</p>
									</div>

									<div className="col-md-4 mb-5 mb-lg-0">
										<span className="mb-3 mx-auto hiw-circle rounded-circle bkg-two">
											<h1>2</h1>
										</span>
										<h4>
											<strong>Log or import hours</strong>
										</h4>
										<p className="mb-0">
											Enter your hours and the requirements for your specific state will apply
										</p>
									</div>

									<div className="col-md-4 mb-5 mb-lg-0">
										<span className="mb-3 mx-auto hiw-circle rounded-circle bkg-three">
											<h1>3</h1>
										</span>
										<h4>
											<strong>Track your progress</strong>
										</h4>
										<p className="mb-0">
											See how far you've come and use the tools mentioned above to stay on track
										</p>
									</div>
								</div>

								<div className={"container text-center"}>
									<h2>
										Start your FREE 15-day trial now
									</h2>

									<div className="row justify-content-center mt-5">
										<a onClick={() => downLoadVisit('ios', this.props.source)}>
											<img src="img/app-store.svg" height="45" width="auto" alt="Appstore download image"/>
										</a>
										<span className="download-space"></span>
										<a onClick={() => downLoadVisit('android', this.props.source)}>
											<img src="img/play-store.svg" height="45" width="auto" alt="Playstore download image"/>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default howitworks



// WEBPACK FOOTER //
// ./src/components/howitworks.jsx